import TagManager from "react-gtm-module";

import config from "config";

function validConfig(gtmConfig, method = "") {
  if (!gtmConfig?.enabled) {
    console.warn("SKIPPING GTM - DISABLED", method);
    return false;
  }

  if (!gtmConfig?.gtmId) {
    console.warn("SKIPPING GTM - CONFIGURATION IS NOT AVAILABLE", method);
    return false;
  }

  return true;
}

export function init(gtmConfig) {
  if (validConfig(gtmConfig, "initialize")) TagManager.initialize(gtmConfig);
}

export function dataLayer(gtmConfig, data) {
  if (validConfig(gtmConfig, "dataLayer")) TagManager.dataLayer(data);
}

export function initWithConfig() {
  init(config.gtm);
}

export function dataLayerWithConfig(data) {
  dataLayer(config.gtm, data);
}
